// src/api/categoriesApi.js

// // Import the categories data (same as in your data.js)
// import { categories } from '../data/categories';

// // Simulate a network delay (like a real API)
// const sleep = (ms) => {
//   return new Promise(resolve => setTimeout(resolve, ms));
// };

// /**
//  * Fetches categories data (mocked until backend is ready)
//  * @returns {Promise<Array>} - Resolves with categories array
//  */
// export const fetchCategories = async () => {
//   try {
//     await sleep(800); // Simulate network latency (0.8 seconds)
//     return categories;
//   } catch (error) {
//     console.error('API Error: Failed to fetch categories', error);
//     throw error;
//   }
// };

// // src/api/categoriesApi.js

// const API_URL = `${process.env.REACT_APP_API_BASE_URL}/products`;

// // Cache object
// let cache = {
//   data: null,
//   timestamp: null,
//   ttl: 5 * 60 * 1000 // 5 minutes in milliseconds
// };

// const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// /**
//  * Fetches categories data from real API with caching
//  * @returns {Promise<Array>} - Resolves with API response
//  */
// export const fetchCategories = async () => {
//   try {
//     // Check if cache is valid
//     const now = Date.now();
//     if (cache.data && cache.timestamp && (now - cache.timestamp) < cache.ttl) {
//       console.log('Using cached categories data');
//       return cache.data;
//     }

//     // Simulate realistic network delay only on actual fetch
//     await sleep(800);

//     const response = await fetch(API_URL);

//     if (!response.ok) {
//       if (cache.data) {
//         console.warn('API failed, using stale cache');
//         return cache.data;
//       }
//       throw new Error(`API Error: ${response.status} ${response.statusText}`);
//     }

//     const data = await response.json();

//     if (!Array.isArray(data)) {
//       throw new Error('Invalid data format received from API');
//     }

//     // Update cache
//     cache.data = data;
//     cache.timestamp = Date.now();

//     console.log('Fetched and cached fresh categories data');
//     return data;
//   } catch (error) {
//     console.error('API Error: Failed to fetch categories', error);

//     // If offline or API fails, serve from cache if available
//     if (cache.data) {
//       console.warn('Network error, using cached data');
//       return cache.data;
//     }

//     if (error.message.includes('Failed to fetch')) {
//       throw new Error('Network error: Unable to connect to server. Please check your internet connection.');
//     }

//     throw error;
//   }
// };

// /**
//  * Manually clear cache (e.g., when you want fresh data)
//  */
// export const clearCategoriesCache = () => {
//   cache.data = null;
//   cache.timestamp = null;
//   console.log('🗑️ Categories cache cleared');
// };

import { getErrorMessage } from "../config/errorConfig";
import { PRODUCT_CATEGORY_URL } from "../config/apiConfig";
const API_URL = PRODUCT_CATEGORY_URL;

// Cache object
let cache = {
  data: null,
  timestamp: null,
  ttl: 5 * 60 * 1000, // 5 minutes in milliseconds
};


/**
 * Fetches categories data from real API with caching
 * Returns data in the original format that Navbar expects
 * @returns {Promise<Array>} - Resolves with categories in original format
 */
export const fetchCategories = async () => {
  try {
    // Check if cache is valid
    const now = Date.now();
    if (cache.data && cache.timestamp && now - cache.timestamp < cache.ttl) {
      return cache.data;
    }


    const response = await fetch(API_URL);

  if (!response.ok) {
      // Use cache if available on API error
      if (cache.data) {
        console.warn("API error, using cached categories");
        return cache.data;
      }

      // Map HTTP status to user-friendly error
      let errorMessage;
      if (response.status >= 500) {
        errorMessage = getErrorMessage("API_SERVER_ERROR");
      } else if (response.status === 404) {
        errorMessage = getErrorMessage("API_NOT_FOUND");
      } else if (response.status === 429) {
        errorMessage = getErrorMessage("API_RATE_LIMITED");
      } else {
        errorMessage = getErrorMessage("API_BAD_REQUEST");
      }

      throw new Error(errorMessage);
    }

    const rawData = await response.json();

    if (!Array.isArray(rawData)) {
      throw new Error(getErrorMessage("API_BAD_REQUEST"));
    }

    // Return data in original format (no transformation needed)
    // The API already returns: { category: "...", subcategories: [...] }
    // This is exactly what the Navbar component expects!

    // Validate the data structure
    const validatedData = rawData.filter((item) => {
      const isValid =
        item &&
        typeof item.category === "string" &&
        Array.isArray(item.subcategories);

      if (!isValid) {
        console.warn("Invalid category item:", item);
      }

      return isValid;
    });


    // Update cache with original format
    cache.data = validatedData;
    cache.timestamp = Date.now();



    return validatedData;
  } catch (error) {
    console.error("💥 API Error: Failed to fetch categories", error);

    // If offline or API fails, serve from cache if available
    if (cache.data) {
      console.warn("Network error, using cached data");
      return cache.data;
    }

    if (error.message.includes("Failed to fetch")) {
      throw new Error(getErrorMessage("NETWORK_SERVER_UNREACHABLE"));
    }

    throw error;
  }
};

/**
 * Alternative function that returns hierarchical format for other parts of the app
 * Use this if you need the transformed format elsewhere
 * @returns {Promise<Array>} - Resolves with transformed category tree
 */
export const fetchCategoriesHierarchical = async () => {
  try {
    // Get the original format first
    const originalData = await fetchCategories();

    // Transform to hierarchical format
    const transformedData = originalData.map((item) => ({
      department_name: item.category,
      index_name: item.category,
      product_types: item.subcategories.map((sub) => ({
        product_type_name: sub,
        products: [],
      })),
    }));

  
    return transformedData;
  } catch (error) {
    console.error("Failed to fetch hierarchical categories:", error);
    throw error;
  }
};

/**
 * Manually clear cache (e.g., when you want fresh data)
 */
export const clearCategoriesCache = () => {
  cache.data = null;
  cache.timestamp = null;
  
};
